import React, { useEffect, useState, useMemo, useCallback } from 'react';
import { Modal, Toast } from 'react-bootstrap';
import { Link, useNavigate, useParams } from 'react-router-dom';
import Api from '../Auth/Api';
import Table from '../Components/Table';
import { useForm, Controller } from 'react-hook-form';
import { pdf } from '@react-pdf/renderer';
import { saveAs } from 'file-saver';
import GerarPDF from '../Components/GerarPDF';
import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';
import { decodeJWT } from '../Components/jwtUtils';
import Select from 'react-select';

function ListaAlunos() {

    const [showModalNotasInd, setShowModalNotasInd] = useState(false);
    const [showModalEnviarProva, setShowModalEnviarProva] = useState(false);
    const [showModalNota, setShowModalNota] = useState({ show: false });
    const [toast, setToast] = useState({});
    const [showToast, setShowToast] = useState(false);
    const [usuarioSelecionado, setUsuarioSelecionado] = useState({});
    const [progressoAvaliacao, setProgressoAvaliacao] = useState('');
    const [shouldGeneratePDF, setShouldGeneratePDF] = useState({ show: false });
    const [progressoAvaliacaoUserID, setProgressoAvaliacaoUserID] = useState(null);
    const [selectedFilter, setSelectedFilter] = useState(null);
    const [selectedTipo, setSelectedTipo] = useState('favoritos');
    const [selectedEmpresa, setSelectedEmpresa] = useState(null);

    // Form para Notas
    const {
        register: registerNota,
        handleSubmit: handleSubmitNota,
        formState: { errors: errorsNota }
    } = useForm();

    // Form para Prática
    const {
        register: registerPratica,
        handleSubmit: handleSubmitPratica,
        formState: { errors: errorsPratica },
        control: controlPratica,
        reset: resetPratica
    } = useForm({
        defaultValues: {
            data_treinamento: '',
            local_treinamento: '',
            gestor: '',
            lista_presenca: null,
            fotos: null
        }
    });

    // Form para Prática em Massa
    const {
        register: registerPraticaMassa,
        handleSubmit: handleSubmitPraticaMassa,
        formState: { errors: errorsPraticaMassa },
        control: controlPraticaMassa,
        reset: resetPraticaMassa
    } = useForm({
        defaultValues: {
            data_treinamento: '',
            local_treinamento: '',
            gestor: '',
            lista_presenca: null,
            fotos: null
        }
    });

    const [checkedStates, setCheckedStates] = useState({});
    const [loading, setLoading] = useState(false);
    const [showModalPratica, setShowModalPratica] = useState(false);
    const [showModalVisualizarPratica, setShowModalVisualizarPratica] = useState(false);
    const [praticaAtual, setPraticaAtual] = useState(null);
    const [praticasRegistradas, setPraticasRegistradas] = useState({});
    const [listaPresencaSelected, setListaPresencaSelected] = useState(false);
    const [fotosSelected, setFotosSelected] = useState(false);
    const [listaPresencaEditSelected, setListaPresencaEditSelected] = useState(false);
    const [fotosEditSelected, setFotosEditSelected] = useState(false);
    const [arquivosSelecionados, setArquivosSelecionados] = useState({
        listaPresenca: null,
        fotos: []
    });
    const [showModalConfirmacao, setShowModalConfirmacao] = useState(false);
    const [usuarioConfirmacao, setUsuarioConfirmacao] = useState(null);
    const [novoStatusCertificado, setNovoStatusCertificado] = useState(false);
    const [showModalEditarPratica, setShowModalEditarPratica] = useState(false);
    const [showModalConfirmacaoDeletar, setShowModalConfirmacaoDeletar] = useState(false);
    const [modalVerAvaliacaoReacao, setModalVerAvaliacaoReacao] = useState({ show: false, tipo: '', data: null });
    const [modalError, setModalError] = useState({ show: false, message: '' });
    const [shouldReopenDetailsModal, setShouldReopenDetailsModal] = useState(false);
    const [loadingRegistrar, setLoadingRegistrar] = useState(false);
    const [loadingEditar, setLoadingEditar] = useState(false);
    const [showModalPraticaMassa, setShowModalPraticaMassa] = useState(false);
    const [alunosSelecionadosMassa, setAlunosSelecionadosMassa] = useState([]);
    const [listaPresencaMassaSelected, setListaPresencaMassaSelected] = useState(false);
    const [fotosMassaSelected, setFotosMassaSelected] = useState(false);
    const [loadingRegistrarMassa, setLoadingRegistrarMassa] = useState(false);
    
    const navigate = useNavigate();
    const token = JSON.parse(localStorage.getItem("user_token"));
    const usuarioLogado = decodeJWT(token);
    const nivel = usuarioLogado.nivel;
    const idUsuarioLogado = usuarioLogado.idUsuario;
    const isAdminOrModerador = nivel === 'Administrador' || nivel === 'Moderador' || nivel === 'Admin' || nivel === 'SuperAdmin';
    const { id } = useParams();

    const handleSwitchChange = useCallback(async (idUsuario, novoStatus) => {
        setUsuarioConfirmacao(idUsuario);
        setNovoStatusCertificado(novoStatus);
        setShowModalConfirmacao(true);
    }, []);

    const confirmarMudancaCertificado = useCallback(async () => {
        try {
            const response = await Api.post(`api/permissao-certificado/${id}/${usuarioConfirmacao}`, {}, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            if (response && response.data) {
                setCheckedStates(prevState => ({
                    ...prevState,
                    [usuarioConfirmacao]: response.data.permissao === 1
                }));
                setToast({
                    header: 'Sucesso!',
                    body: `Certificado ${novoStatusCertificado ? 'liberado' : 'bloqueado'} com sucesso!`
                });
                setShowToast(true);
            }
        } catch (error) {
            setToast({
                header: 'Ops!',
                body: error.response?.data?.message || 'Erro ao alterar permissão do certificado'
            });
            setShowToast(true);
        }
        setShowModalConfirmacao(false);
    }, [id, token, usuarioConfirmacao, novoStatusCertificado]);

    const onSubmitNota = async (data) => {

        data['tipo'] = showModalNota.tipo;

        try {
            const response = await Api.post(`/api/editar-nota-avaliacao/${showModalNota.id}`, data, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            setToast({ header: 'Sucesso!', body: response.data.message })

        } catch (error) {
            setToast({ header: 'Ops!', body: error.response.data.message })
            console.error("Erro ao editar a nota:", error);
        }

        setShowToast(true);
        setShowModalNota({ show: false })
        setShowModalNotasInd(true)
    };

    const onSubmitPratica = async (data) => {
        setLoadingRegistrar(true);
        const formData = new FormData();
        formData.append('data_treinamento', data.data_treinamento);
        formData.append('local_treinamento', data.local_treinamento);
        formData.append('gestor', data.gestor);

        if (data.lista_presenca instanceof FileList) {
            formData.append('lista_presenca', data.lista_presenca[0]);
        }

        if (data.fotos instanceof FileList) {
            for (let i = 0; i < data.fotos.length; i++) {
                formData.append(`fotos[${i}]`, data.fotos[i]);
            }
        }

        try {
            const response = await Api.post(`/api/registrar-pratica/${id}/${usuarioSelecionado.id}`, formData, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'multipart/form-data'
                }
            });

            // Atualizar o estado localmente com a prática recém-registrada
            if (response.data.pratica && response.data.pratica.id) {
                const praticaMap = { ...praticasRegistradas };
                praticaMap[usuarioSelecionado.id] = { ativa: true, id: response.data.pratica.id };
                setPraticasRegistradas(praticaMap);
            }

            setToast({ header: 'Sucesso!', body: response.data.message });
            setShowModalPratica(false);
            resetPratica();
            setListaPresencaSelected(false);
            setFotosSelected(false);
        } catch (error) {
            setToast({ header: 'Ops!', body: error.response?.data?.message || 'Erro ao registrar prática' });
        }
        setShowToast(true);
    };

    const onSubmitPraticaMassa = async (data) => {
        setLoadingRegistrarMassa(true);
        const formData = new FormData();

        // Adicionar array de IDs dos alunos
        formData.append('idUsuarios', JSON.stringify(alunosSelecionadosMassa.map(a => a.id)));

        // Adicionar dados do treinamento
        formData.append('data_treinamento', data.data_treinamento);
        formData.append('local_treinamento', data.local_treinamento);
        formData.append('gestor', data.gestor);

        // Adicionar arquivos
        if (data.lista_presenca instanceof FileList) {
            formData.append('lista_presenca', data.lista_presenca[0]);
        }

        if (data.fotos instanceof FileList) {
            for (let i = 0; i < data.fotos.length; i++) {
                formData.append(`fotos[${i}]`, data.fotos[i]);
            }
        }

        try {
            const response = await Api.post(`/api/registrar-pratica-massa/${id}`, formData, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'multipart/form-data'
                }
            });

            setToast({ header: 'Sucesso!', body: response.data.message });
            setShowModalPraticaMassa(false);
            resetPraticaMassa();
            setAlunosSelecionadosMassa([]);
            setListaPresencaMassaSelected(false);
            setFotosMassaSelected(false);

            // Recarregar práticas para atualizar UI
            try {
                const responsePraticas = await Api.get(`/api/cursos/${id}/praticas`, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
                const praticasMap = {};
                responsePraticas.data.forEach(pratica => {
                    praticasMap[pratica.idUsuario] = {
                        ativa: !pratica.arquivado,
                        id: pratica.id,
                        arquivada: pratica.arquivado
                    };
                });
                setPraticasRegistradas(praticasMap);
            } catch (error) {
                console.error('Erro ao recarregar práticas:', error);
            }
        } catch (error) {
            setToast({ header: 'Ops!', body: error.response?.data?.message || 'Erro ao registrar práticas' });
        } finally {
            setLoadingRegistrarMassa(false);
        }
        setShowToast(true);
    };

    const [dataInfoCurso, setDataInfoCurso] = useState([]);
    useEffect(() => {
        async function fetchData() {
            try {
                const response = await Api.get(`api/info-curso/${id}`, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
                setDataInfoCurso(response.data);
            } catch (error) {
                console.error(error.response.data.message)
                // navigate("/");
            }
        }

        fetchData();
    }, [token, id, navigate]);

    const [dataEmpresas, setDataEmpresas] = useState([]);
    useEffect(() => {
        async function fetchData() {
            // Gestores não precisam carregar lista de empresas
            if (nivel === 'Gestor') return;

            try {
                const response = await Api.get(`api/listar-empresas`, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
                setDataEmpresas(response.data);
            } catch (error) {
                console.error(error);
            }
        }
        fetchData();
    }, [token, nivel]);

    const [alunos, setAlunos] = useState([]);
    useEffect(() => {
        setLoading(true);
        async function fetchData() {
            try {
                const response = await Api.get(`api/listar-usuarios-por-curso/${id}/${selectedTipo}`, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    },
                    params: {
                        empresa: selectedEmpresa ? selectedEmpresa.value : undefined,
                    }
                });

                // Aqui você inicializa o estado checkedStates
                const initialStates = {};
                response.data.forEach(usuario => {
                    initialStates[usuario.id] = usuario.certificado === 1;
                });
                setCheckedStates(initialStates);
                setLoading(false);
                setAlunos(response.data);
            } catch (error) {
                setLoading(false);
                console.error(error.response.data.message)
            }
        }
        fetchData();
    }, [token, id, navigate, toast, selectedTipo, selectedEmpresa]);

    const filterSelect = [
        { value: 'todos', label: 'Todos' },
        { value: 'andamento', label: 'Em andamento' },
        { value: 'finalizados', label: 'Finalizados' }
    ]

    const filterTipo = [
        { value: 'favoritos', label: 'Favoritos' },
        { value: 'todos', label: 'Todos' }
    ]

    // Criando os filtros a partir da api do Alunos
    let filterAlunos = alunos;
    switch (selectedFilter) {
        case "todos":
            filterAlunos = alunos;
            break;
        case "andamento":
            filterAlunos = alunos.filter(value => parseInt(value.aulas_finalizadas) > 0 && parseInt(value.porcentagem_concluida) !== 100);
            break;
        case "finalizados":
            filterAlunos = alunos.filter(value => parseInt(value.porcentagem_concluida) === 100);
            break;
        default:
            break;
    }

    useEffect(() => {
        setProgressoAvaliacao('') // Limpa antes de recarregar
        if (shouldGeneratePDF.show && progressoAvaliacao && usuarioSelecionado.id === progressoAvaliacaoUserID) {

            const doc = <GerarPDF data={progressoAvaliacao} titulo={shouldGeneratePDF.nome} tipo='avaliacao' />;
            pdf(doc).toBlob().then(blob => {
                saveAs(blob, `avaliacao_${usuarioSelecionado.nome_completo}_${shouldGeneratePDF.nome}.pdf`);
                setShouldGeneratePDF({ show: false });  // Reset após gerar o PDF
            });
        }
    }, [shouldGeneratePDF, progressoAvaliacao, usuarioSelecionado.nome_completo, usuarioSelecionado.id, progressoAvaliacaoUserID]);

    //Listar avaliacao e respostas do usuario
    useEffect(() => {
        async function fetchData(idUsuario, tipo) {
            try {
                const response = await Api.get(`api/${tipo === 'EX' ? 'info-progresso-avaliacao-extra-usuario' : 'info-progresso-avaliacao-usuario'}/${shouldGeneratePDF.id}/${idUsuario}`, { headers: { Authorization: `Bearer ${token}` } });
                setProgressoAvaliacao(response.data);
                setProgressoAvaliacaoUserID(idUsuario); // Defina o ID do usuário para o qual os dados se aplicam

            } catch (error) {
                console.error(error.response.data.message)
            }
        }
        if (usuarioSelecionado.id && shouldGeneratePDF.id) {
            fetchData(usuarioSelecionado.id, shouldGeneratePDF.tipo);
        }
    }, [usuarioSelecionado.id, id, token, shouldGeneratePDF]);

    const [dataModulos, setDataModulos] = useState([]);
    useEffect(() => {
        async function fetchData() {
            try {
                if (!usuarioSelecionado.id) return; // Evita chamadas desnecessárias

                // Resetar o estado de erro do modal
                setModalError({ show: false, message: '' });

                const response = await Api.get(`api/listar-progresso-avaliacao-curso/${id}/${usuarioSelecionado.id}?incluir_arquivados=1`, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
                setDataModulos(response.data);
            } catch (error) {
                console.error(error);
                if (error.response && error.response.data && error.response.data.message) {
                    // Mostrar erro dentro do modal em vez de fechar o modal
                    setModalError({
                        show: true,
                        message: error.response.data.message
                    });
                    setDataModulos([]); // Limpa os dados
                } else {
                    // Mostrar erro dentro do modal para outros tipos de erro
                    setModalError({
                        show: true,
                        message: 'Ocorreu um erro ao carregar as avaliações.'
                    });
                }
            }
        }
        if (showModalNotasInd && usuarioSelecionado.id) {
            fetchData();
        }
    }, [id, token, usuarioSelecionado.id, showModalNotasInd])

    const verificarPraticaExistente = useCallback(async (idCurso, idUsuario) => {
        try {
            // Em vez de fazer duas chamadas API para verificar práticas ativas e arquivadas,
            // use os dados que já foram carregados no estado praticasRegistradas
            const praticaInfoMap = praticasRegistradas[idUsuario];

            if (praticaInfoMap) {
                // Se já temos a informação da prática, buscamos apenas os detalhes
                const detalhes = await Api.get(`/api/praticas/${praticaInfoMap.id}`, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
                setPraticaAtual({ ...detalhes.data, arquivada: !praticaInfoMap.ativa });
                setShowModalVisualizarPratica(true);
            } else {
                // Se não encontrou, abre o modal de registro
                setShowModalPratica(true);
            }
        } catch (error) {
            setToast({
                header: 'Ops!',
                body: error.response?.data?.message || 'Erro ao verificar prática existente'
            });
            setShowToast(true);
        }
    }, [token, setPraticaAtual, setShowModalVisualizarPratica, setShowModalPratica, setToast, setShowToast, praticasRegistradas]);

    useEffect(() => {
        async function fetchPraticas() {
            try {
                // Uma única chamada para buscar práticas ativas e arquivadas em paralelo
                const [responseAtivas, responseArquivadas] = await Promise.all([
                    Api.get(`/api/cursos/${id}/praticas`, {
                        headers: {
                            Authorization: `Bearer ${token}`
                        }
                    }),
                    Api.get(`/api/cursos/${id}/praticas?arquivadas=true`, {
                        headers: {
                            Authorization: `Bearer ${token}`
                        }
                    })
                ]);

                const praticasMap = {};

                // Mapear práticas ativas
                responseAtivas.data.forEach(pratica => {
                    praticasMap[pratica.idUsuario] = { ativa: true, id: pratica.id };
                });

                // Mapear práticas arquivadas
                responseArquivadas.data.forEach(pratica => {
                    // Se o usuário já tem uma prática ativa, não sobreescreve
                    if (!praticasMap[pratica.idUsuario]) {
                        praticasMap[pratica.idUsuario] = { ativa: false, id: pratica.id, arquivada: true };
                    }
                });

                setPraticasRegistradas(praticasMap);
            } catch (error) {
                console.error('Erro ao buscar práticas:', error);
            }
        }

        if (id) {
            fetchPraticas();
        }
    }, [id, token, showModalPratica, showModalVisualizarPratica]);

    // Vamos adicionar uma função para buscar os dados completos do usuário
    const buscarDadosUsuario = useCallback(async (idUsuario) => {
        try {
            const response = await Api.get(`/api/usuario/${idUsuario}`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            // Atualiza o usuário selecionado com os dados completos, incluindo gestor_responsavel
            setUsuarioSelecionado(prevState => ({
                ...prevState,
                ...response.data
            }));

            return response.data;
        } catch (error) {
            console.error('Erro ao buscar dados do usuário:', error);
            setToast({
                header: 'Erro!',
                body: 'Não foi possível obter os dados completos do usuário.'
            });
            setShowToast(true);
            return null;
        }
    }, [token, setToast]);

    // Modificar o click handler para buscar os dados completos antes de mostrar o modal
    const handleVerNotas = useCallback(async (usuario) => {
        setUsuarioSelecionado(usuario);
        await buscarDadosUsuario(usuario.id);
        setShowModalNotasInd(true);
    }, [buscarDadosUsuario, setUsuarioSelecionado, setShowModalNotasInd]);

    // Função para verificar acesso às avaliações de reação
    const handleVerAvaliacaoReacao = useCallback(async (tipo, data) => {
        let shouldContinue = true;

        // Verificar se temos os dados completos do usuário
        if (!usuarioSelecionado.gestor_responsavel) {
            try {
                // Garantir que aguardamos a conclusão da busca
                await buscarDadosUsuario(usuarioSelecionado.id);
            } catch (error) {
                console.error('Erro ao buscar dados do usuário:', error);
                shouldContinue = false;
            }
        }

        if (!shouldContinue) {
            setToast({
                header: 'Erro!',
                body: 'Não foi possível obter os dados do usuário para verificar permissões.'
            });
            setShowToast(true);
            return;
        }

        // Verificar se o usuário tem permissão para ver a avaliação de reação
        const gestorResponsavelId = usuarioSelecionado.gestor_responsavel;
        const isGestorResponsavel = String(gestorResponsavelId) === String(idUsuarioLogado);
        const canViewReactionEvaluation = isAdminOrModerador || (nivel === 'Gestor' && isGestorResponsavel);

        if ((tipo === 'Avaliação de Reação' || tipo === 'Avaliação de Reação Híbrida') && !canViewReactionEvaluation) {
            setToast({
                header: 'Acesso Negado',
                body: 'Apenas o gestor responsável, Administradores e Moderador podem ver avaliações de reação.'
            });
            setShowToast(true);
            return;
        }

        // Exibir o modal de visualização da avaliação
        setModalVerAvaliacaoReacao({
            show: true,
            tipo,
            data
        });
    }, [buscarDadosUsuario, idUsuarioLogado, isAdminOrModerador, nivel, usuarioSelecionado, setToast, setModalVerAvaliacaoReacao]);

    // Função para exportar avaliação de reação para Excel
    const exportarAvaliacaoReacaoExcel = useCallback(() => {
        if (!modalVerAvaliacaoReacao.data) return;

        try {
            // Importar a biblioteca Excel
            const XLSX = require('xlsx');

            // Dados do aluno e módulo para a planilha
            const infoData = {
                "Aluno": usuarioSelecionado.nome_completo,
                "Código": usuarioSelecionado.codigo,
                "Unidade": usuarioSelecionado.unidade,
                "Curso": dataInfoCurso[0]?.nome || "Não disponível",
                "Módulo": modalVerAvaliacaoReacao.data.nomeModulo,
                "Tipo de Avaliação": modalVerAvaliacaoReacao.tipo,
                "Data Avaliação": modalVerAvaliacaoReacao.data.data_formatada
            };

            // Buscar dados do gestor responsável, se disponível
            let gestorData = {
                "Gestor Responsável": "Não disponível"
            };

            // Função para continuar a exportação após obter dados do gestor
            const continuarExportacao = (gestorData) => {
                // Preparar os dados das respostas
                let respostasData = [];

                try {
                    if (modalVerAvaliacaoReacao.tipo === 'Avaliação de Reação' || modalVerAvaliacaoReacao.tipo === 'Avaliação de Reação Híbrida') {
                        // Garantir que questoes e respostas estão em formato adequado
                        const questoes = typeof modalVerAvaliacaoReacao.data.questoes === 'string'
                            ? JSON.parse(modalVerAvaliacaoReacao.data.questoes)
                            : modalVerAvaliacaoReacao.data.questoes;

                        const respostas = typeof modalVerAvaliacaoReacao.data.respostas === 'string'
                            ? JSON.parse(modalVerAvaliacaoReacao.data.respostas)
                            : modalVerAvaliacaoReacao.data.respostas;

                        if (Array.isArray(questoes) && Array.isArray(respostas)) {
                            respostasData = questoes.map((questao, index) => ({
                                "Pergunta": questao,
                                "Resposta": respostas[index] || "Não respondida"
                            }));
                        }
                    } else {
                        // Renderização para avaliações normais
                        const respostasObj = typeof modalVerAvaliacaoReacao.data.respostas === 'string'
                            ? JSON.parse(modalVerAvaliacaoReacao.data.respostas)
                            : modalVerAvaliacaoReacao.data.respostas;

                        const questoesObj = typeof modalVerAvaliacaoReacao.data.questoes === 'string'
                            ? JSON.parse(modalVerAvaliacaoReacao.data.questoes)
                            : modalVerAvaliacaoReacao.data.questoes;

                        respostasData = Object.entries(respostasObj).map(([perguntaId, resposta]) => {
                            const questaoTexto = questoesObj[perguntaId]?.questao || `Pergunta ${Number(perguntaId) + 1}`;
                            return {
                                "Pergunta": questaoTexto,
                                "Resposta": resposta
                            };
                        });
                    }
                } catch (error) {
                    console.error('Erro ao processar dados para Excel:', error);
                    respostasData = [{
                        "Erro": "Não foi possível processar os dados das respostas",
                        "Detalhes": error.message
                    }];
                }

                // Criar uma nova planilha
                const workbook = XLSX.utils.book_new();

                // Adiciona planilha com dados do curso e aluno
                const worksheetInfo = XLSX.utils.json_to_sheet([infoData]);
                XLSX.utils.book_append_sheet(workbook, worksheetInfo, "Informações");

                // Adiciona planilha com dados do gestor
                const worksheetGestor = XLSX.utils.json_to_sheet([gestorData]);
                XLSX.utils.book_append_sheet(workbook, worksheetGestor, "Gestor");

                // Adiciona planilha de respostas
                const worksheetRespostas = XLSX.utils.json_to_sheet(respostasData);
                XLSX.utils.book_append_sheet(workbook, worksheetRespostas, "Respostas");

                // Adiciona comentários, se houver
                if (modalVerAvaliacaoReacao.data.comentarios) {
                    const comentariosData = [{
                        "Comentários": modalVerAvaliacaoReacao.data.comentarios
                    }];
                    const worksheetComentarios = XLSX.utils.json_to_sheet(comentariosData);
                    XLSX.utils.book_append_sheet(workbook, worksheetComentarios, "Comentários");
                }

                // Gera o arquivo e realiza o download
                const tipoAvaliacao = modalVerAvaliacaoReacao.tipo === 'Avaliação de Reação Híbrida' ? 'Reacao_Hibrida' : 'Reacao';
                const nomeArquivo = `Avaliacao_${tipoAvaliacao}_${usuarioSelecionado.nome_completo.replace(/\s+/g, '_')}_${new Date().toISOString().split('T')[0]}.xlsx`;
                XLSX.writeFile(workbook, nomeArquivo);

                setToast({
                    header: 'Sucesso!',
                    body: 'Relatório de avaliação de reação exportado com sucesso!'
                });
                setShowToast(true);
            };

            // Verificar se temos o gestor_responsavel do usuário
            if (usuarioSelecionado.gestor_responsavel) {
                Api.get(`/api/usuario/${usuarioSelecionado.gestor_responsavel}`, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                }).then(response => {
                    if (response.data) {
                        gestorData = {
                            "Gestor Responsável": response.data.nome_completo || "Não disponível",
                            "Email do Gestor": response.data.email || "Não disponível",
                            "Unidade do Gestor": response.data.unidade || "Não disponível"
                        };
                    }
                    continuarExportacao(gestorData);
                }).catch(error => {
                    console.warn("Não foi possível obter dados do gestor:", error);
                    continuarExportacao(gestorData);
                });
            } else {
                continuarExportacao(gestorData);
            }
        } catch (error) {
            console.error("Erro ao exportar para Excel:", error);
            setToast({
                header: 'Erro!',
                body: 'Falha ao exportar. Verifique o console para mais detalhes.'
            });
            setShowToast(true);
        }
    }, [modalVerAvaliacaoReacao, usuarioSelecionado, dataInfoCurso, setToast, token]);

    const columns = useMemo(
        () => [
            {
                Header: () => null,
                id: 'foto',
                Cell: () => (
                    <div className="d-flex align-items-center">
                        <div className="picture text-white bg-grey" style={{ fontSize: '22px', height: '42px', marginRight: '0px', width: '42px' }}>
                            <i className="bi bi-person" />
                        </div>
                    </div>
                )
            },
            {
                Header: () => null,
                accessor: 'nome_completo',
                Cell: ({ cell: { value }, row: { original } }) => (
                    <>
                        <div className=''>{value}</div>
                        <div className='d-flex align-items-center gap-2'>
                            <div className='badge bg-primary'>{original.codigo}</div>
                            <Tippy content={original.email}>
                                <i className="bi bi-envelope-fill text-primary cursor-pointer"></i>
                            </Tippy>
                        </div>
                    </>
                )
            },
            // Coluna de empresa - apenas para Admin/Moderador
            ...(nivel !== 'Gestor' ? [{
                Header: () => null,
                accessor: 'empresa_nome',
                Cell: ({ cell: { value } }) => (
                    <div className="text-center">
                        <span className="badge bg-secondary">{value || 'Sem empresa'}</span>
                    </div>
                )
            }] : []),
            {
                Header: () => null,
                accessor: 'status',
                Cell: ({ cell: { value }, row: { original } }) => (
                    <div className="text-center">
                        <div className={`badge bg-${value === 'Pendente' ? 'dark' :
                            value === 'Em progresso' ? 'warning' :
                                value === 'Aprovado' ? 'success' :
                                    'primary'
                            }`}>{value}</div>
                    </div>
                )
            },
            {
                Header: () => null,
                accessor: 'email',
                visible: false
            },
            {
                Header: () => null,
                accessor: 'porcentagem_concluida',
                Cell: ({ cell: { value }, row: { original } }) => {
                    let texto = '';
                    let color = 'primary';
                    let width = 0;
                    let textColor = 'text-light';

                    if (parseInt(value) === 100) {
                        texto = 'Concluído';
                        color = 'success';
                        width = 100;
                    }
                    if (parseInt(value) < 100) {
                        texto = `${value}%`;
                        width = value;
                    }
                    if (parseInt(original.aulas_finalizadas) > 0 && parseInt(value) !== 100) {
                        texto = `Em andamento`;
                        width = 100;
                        color = 'none';
                        textColor = 'text-dark';
                    }

                    return (
                        <div className="progress">
                            <div className={`progress-bar progress-bar-striped progress-bar-animated bg-${color} ${textColor}`} style={{ width: width + '%' }}>
                                {texto}
                            </div>
                        </div>
                    )
                }
            },
            {
                Header: () => null,
                id: 'pratica',
                Cell: ({ row: { original } }) => (
                    dataInfoCurso[0].tipo === 'misto' && (
                        <div className="text-center">
                            <Tippy content={
                                praticasRegistradas[original.id]?.ativa
                                    ? "Visualizar Prática"
                                    : praticasRegistradas[original.id]?.arquivada
                                        ? "Visualizar Prática Arquivada"
                                        : nivel !== "Administrador"
                                            ? "Sem permissão"
                                            : "Registrar Prática"
                            }>
                                <button
                                    onClick={() => {
                                        if (nivel !== "Administrador" && !praticasRegistradas[original.id]) return;
                                        setUsuarioSelecionado(original);
                                        verificarPraticaExistente(id, original.id);
                                    }}
                                    className={`btn btn-outline-${praticasRegistradas[original.id]?.ativa
                                        ? 'success'
                                        : praticasRegistradas[original.id]?.arquivada
                                            ? 'warning'
                                            : 'primary'
                                        } text-${praticasRegistradas[original.id]?.ativa
                                            ? 'success'
                                            : praticasRegistradas[original.id]?.arquivada
                                                ? 'warning'
                                                : 'primary'
                                        } rounded px-2 ${nivel !== "Administrador" && !praticasRegistradas[original.id] ? 'opacity-50 cursor-not-allowed' : ''}`}
                                >
                                    <i className={`bi bi-${praticasRegistradas[original.id]?.ativa
                                        ? 'check-circle'
                                        : praticasRegistradas[original.id]?.arquivada
                                            ? 'archive'
                                            : 'person-workspace'
                                        }`}></i>
                                </button>
                            </Tippy>
                        </div>
                    )
                )
            },
            {
                Header: () => null,
                id: 'notas',
                accessor: row => row.id,
                Cell: ({ cell: { value }, row: { original } }) => (
                    <div>
                        <Tippy content={original.tem_notas_disponiveis ? "Conferir notas" : "Notas não disponíveis"}>
                            <button
                                className={`btn btn-outline-primary justify-content-center align-items-center rounded px-2 me-2 ${!original.tem_notas_disponiveis ? 'cursor-not-allowed opacity-50' : ''}`}
                                onClick={() => {
                                    if (!original.tem_notas_disponiveis) return;
                                    handleVerNotas({ id: original.id, nome_completo: original.nome_completo });
                                }}>
                                <i className="bi bi-file-text" />
                            </button>
                        </Tippy>
                    </div>
                )
            },
            {
                Header: () => null,
                id: 'certificado',
                accessor: row => row.id,
                Cell: ({ cell: { value }, row: { original } }) => {
                    const isDisabled = !(original.status === 'Aprovado' &&
                        (dataInfoCurso[0].tipo !== 'misto' ||
                            (praticasRegistradas[original.id]?.ativa || praticasRegistradas[original.id]?.arquivada)) &&
                        nivel === "Administrador");
                    return (
                        <div className='d-flex align-items-center justify-content-center'>
                            <div className="form-check form-switch">
                                <Tippy content={
                                    original.status !== 'Aprovado'
                                        ? "Usuário precisa estar aprovado"
                                        : !original.avaliacao_reacao_respondida
                                            ? "Usuário precisa responder a avaliação de reação"
                                            : dataInfoCurso[0].tipo === 'misto' && !praticasRegistradas[original.id]
                                                ? "Usuário precisa concluir a prática"
                                                : nivel !== "Administrador"
                                                    ? "Apenas administradores podem alterar"
                                                    : "Permitir certificado"
                                }>
                                    {isDisabled ? (
                                        <div className="cursor-not-allowed text-muted" style={{ marginLeft: "-2em" }}>
                                            <i className="bi bi-lock-fill fs-5"></i>
                                        </div>
                                    ) : (
                                        <input
                                            className="form-check-input cursor-pointer"
                                            type="checkbox"
                                            role="switch"
                                            checked={checkedStates[original.id] || false}
                                            onChange={() => handleSwitchChange(original.id, !checkedStates[original.id])}
                                        />
                                    )}
                                </Tippy>
                            </div>
                        </div>
                    )
                }
            },
            {
                Header: 'Codigo',
                accessor: 'codigo',
                visible: false  // Esta coluna será filtrada, mas não exibida
            }
        ],
        [checkedStates, handleSwitchChange, nivel, dataInfoCurso, praticasRegistradas, id, verificarPraticaExistente, handleVerNotas]
    );

    const LoadingScreen = () => {
        return (
            <div className="d-flex align-items-center justify-content-center p-5">
                <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Carregando...</span>
                </div>
            </div>
        )
    }

    const {
        register: registerEditarPratica,
        handleSubmit: handleSubmitEditarPratica,
        formState: { errors: errorsEditarPratica },
        control: controlEditarPratica,
        reset: resetEditarPratica
    } = useForm();

    const handleEditarPratica = () => {
        resetEditarPratica({
            data_treinamento: praticaAtual.data_treinamento,
            local_treinamento: praticaAtual.local_treinamento,
            gestor: praticaAtual.gestor
        });
        setShowModalVisualizarPratica(false);
        setShowModalEditarPratica(true);
    };

    const onSubmitEditarPratica = async (data) => {
        setLoadingEditar(true);
        const formData = new FormData();
        formData.append('data_treinamento', data.data_treinamento);
        formData.append('local_treinamento', data.local_treinamento);
        formData.append('gestor', data.gestor);

        if (data.lista_presenca instanceof FileList) {
            formData.append('lista_presenca', data.lista_presenca[0]);
        }

        if (data.fotos instanceof FileList) {
            for (let i = 0; i < data.fotos.length; i++) {
                formData.append(`fotos[${i}]`, data.fotos[i]);
            }
        }

        try {
            const response = await Api.post(`/api/editar-praticas/${praticaAtual.id}`, formData, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'multipart/form-data'
                }
            });

            // Se a edição foi bem-sucedida, atualizar a prática atual com os novos dados
            if (response.data.pratica) {
                setPraticaAtual({
                    ...praticaAtual,
                    ...response.data.pratica,
                    data_treinamento: data.data_treinamento,
                    local_treinamento: data.local_treinamento,
                    gestor: data.gestor
                });
            }

            setToast({ header: 'Sucesso!', body: response.data.message });
            // Fecha o modal de edição
            setShowModalEditarPratica(false);
            // Não reabre o modal de visualização
            setShowModalVisualizarPratica(false);
        } catch (error) {
            setToast({ header: 'Ops!', body: error.response?.data?.message || 'Erro ao editar prática' });
        } finally {
            setLoadingEditar(false);
        }
        setShowToast(true);
    };

    const handleDeletarPratica = async () => {
        try {
            const response = await Api.delete(`/api/praticas/${praticaAtual.id}`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            // Atualizar o estado localmente em vez de fazer outra chamada API
            const updatedPraticasMap = { ...praticasRegistradas };
            delete updatedPraticasMap[usuarioSelecionado.id];
            setPraticasRegistradas(updatedPraticasMap);

            setToast({ header: 'Sucesso!', body: response.data.message });
            setShowModalConfirmacaoDeletar(false);
            setShouldReopenDetailsModal(false); // Não reabrir pois a prática foi deletada
        } catch (error) {
            setToast({ header: 'Ops!', body: error.response?.data?.message || 'Erro ao deletar prática' });
        }
        setShowToast(true);
    };

    return (
        <>
            <Toast show={showToast} onClose={() => setShowToast(false)} delay={3000} autohide style={{ position: 'fixed', left: '95%', bottom: '10px', transform: 'translateX(-95%)', zIndex: 9999, padding: 0 }}>
                <Toast.Header>
                    <strong className="mr-auto">{toast.header}</strong>
                </Toast.Header>
                <Toast.Body>{toast.body}</Toast.Body>
            </Toast>

            <Link onClick={() => navigate(-1)} className="btn text-primary link border-0 fs-6 mb-4"><i className="bi bi-chevron-left"></i>Voltar</Link>

            {dataInfoCurso[0] &&
                <div className="fade-in w-100">
                    <span className="text-primary fs-2">Análise geral dos alunos</span>
                    <p className="fs-6">
                        Lista de alunos disponíveis para o curso <span className='fw-bold'>{dataInfoCurso[0].nome}</span>
                    </p>

                    <div className="d-flex justify-content-end mb-3">
                        {dataInfoCurso[0]?.tipo === 'misto' && (
                            <button
                                className="btn btn-primary text-white"
                                onClick={() => {
                                    setAlunosSelecionadosMassa([]);
                                    setShowModalPraticaMassa(true);
                                }}
                            >
                                <i className="bi bi-people-fill me-2"></i>
                                Registrar Prática em Massa
                            </button>
                        )}
                    </div>

                    <div className={loading ? "" : "d-none"}><LoadingScreen /></div>
                    <div className={loading ? "d-none" : ""}>
                        <Table
                            columns={columns}
                            data={filterAlunos}
                            filterSelect={filterSelect}
                            filterTipo={filterTipo}
                            setSelectedTipo={setSelectedTipo}
                            setSelectedFilter={setSelectedFilter}
                            titulo={dataInfoCurso[0].nome}
                            empresas={nivel === 'Gestor' ? [] : dataEmpresas}
                            selectedEmpresa={nivel === 'Gestor' ? null : selectedEmpresa}
                            setSelectedEmpresa={nivel === 'Gestor' ? null : setSelectedEmpresa}
                        />
                    </div>

                </div>
            }

            <Modal size="lg" show={showModalNota.show} onHide={() => { setShowModalNota({ show: false }); setShowModalNotasInd(true) }}>
                <Modal.Header closeButton>
                    <span className="fw-semibold fs-4 text-primary">Trocar Nota <span className='text-dark fs-5'>({usuarioSelecionado.nome_completo})</span></span>
                </Modal.Header>
                <Modal.Body>
                    <form onSubmit={handleSubmitNota(onSubmitNota)}>
                        <div className="row">
                            <div className="col-md-12">
                                <div className="body">
                                    <div className="row">
                                        <div className='label text-start fs-6 py-2 px-3'>Qual a nota para <span className='fw-bold'>{showModalNota.nome}</span></div>
                                        <div className="col">
                                            <input type="number" {...registerNota('nota', { required: true })} className="form-control" placeholder="Digite a nota" />
                                            <input type="hidden" {...registerNota('idUsuario', { required: true })} />
                                        </div>
                                        <div className="col">
                                            <input type="submit" className="btn btn-primary text-white w-100" value="Trocar nota" />
                                        </div>
                                        {errorsNota.nota && <span className='text-danger fs-7'>Nota é obrigatório.</span>}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </Modal.Body>
            </Modal>

            <Modal size="xl" show={showModalNotasInd} onHide={() => { setShowModalNotasInd(false); setUsuarioSelecionado({}); setDataModulos([]); setModalError({ show: false, message: '' }); }}>
                <Modal.Body>
                    <div className='row col-12'>
                        <p className="fw-semibold fs-2 text-primary text-center" style={{ marginBottom: '-5px' }}>{usuarioSelecionado.nome_completo}</p>
                        <p className="fw-semibold fs-4 text-dark text-center text-uppercase">{dataInfoCurso[0] && dataInfoCurso[0].nome}</p>
                    </div>

                    {modalError.show ? (
                        <div className="alert alert-danger mt-3">
                            <div className="d-flex align-items-center">
                                <i className="bi bi-exclamation-triangle-fill fs-4 me-2"></i>
                                <div>
                                    <h5 className="alert-heading">Acesso Negado</h5>
                                    <p className="mb-0">{modalError.message}</p>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div className="row">
                            <div className="col-md-12">
                                <div className="body">
                                    <div className="table-full-width mt-3 mb-3">
                                        <div className="table-responsive">
                                            <table className="table align-middle mt-1">
                                                <thead>
                                                    <tr className='text-nowrap'>
                                                        <th className='text-uppercase text-black-50 fw-bold fs-8 bg-muted'>Curso/Módulo</th>
                                                        <th className='text-uppercase text-black-50 fw-bold fs-8 bg-muted text-center'>Tipo</th>
                                                        <th className='text-uppercase text-black-50 fw-bold fs-8 bg-muted text-center'>Nota</th>
                                                        <th className='text-uppercase text-black-50 fw-bold fs-8 bg-muted text-center'>Data</th>
                                                        <th className='text-uppercase text-black-50 fw-bold fs-8 bg-muted text-center'>Avaliação</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        dataModulos && dataModulos.map((value, index) => {
                                                            const rowClass = index % 2 === 0 ? 'even-row' : 'odd-row';
                                                            return (
                                                                ((value.progresso_avaliacoes && value.progresso_avaliacoes.length > 0) || value.progresso_avaliacao_extras) &&
                                                                <>
                                                                    {value.progresso_avaliacoes && value.progresso_avaliacoes.map((avaliacao, idx) => (
                                                                        <tr key={`pa-${value.id}-${idx}`}>
                                                                            <td className={`${rowClass} fw-semibold`}>{value.nome}</td>
                                                                            <td className={`${rowClass} text-center`}>{avaliacao.tipo}</td>
                                                                            <td className={`${rowClass} text-center fw-bold ${avaliacao.tipo === 'Avaliação de Reação' || avaliacao.tipo === 'Avaliação de Reação Híbrida'
                                                                                ? ''
                                                                                : (avaliacao.nota < 6 ? 'text-primary' : 'text-dark')
                                                                                }`}>
                                                                                {avaliacao.tipo === 'Avaliação de Reação' || avaliacao.tipo === 'Avaliação de Reação Híbrida' ? '-' : (avaliacao.nota || 'N/A')}
                                                                            </td>
                                                                            <td className={`${rowClass} text-center`}>{avaliacao.data_formatada || 'N/A'}</td>
                                                                            <td className={`${rowClass} text-center`}>
                                                                                {avaliacao.tipo === 'Avaliação de Reação' || avaliacao.tipo === 'Avaliação de Reação Híbrida' ? (
                                                                                    <span className='text-primary cursor-pointer' onClick={() => {
                                                                                        handleVerAvaliacaoReacao(avaliacao.tipo, avaliacao);
                                                                                    }}>Ver Respostas</span>
                                                                                ) : (
                                                                                    <span className='text-primary cursor-pointer' onClick={() => {
                                                                                        setShouldGeneratePDF({ show: true, id: value.id, nome: value.nome, tipo: avaliacao.tipo })
                                                                                    }}>Visualizar</span>
                                                                                )}
                                                                            </td>
                                                                        </tr>
                                                                    ))}
                                                                    {
                                                                        value.progresso_avaliacao_extras && value.progresso_avaliacao_extras.map((value, index) => {
                                                                            return (
                                                                                <tr key={`pae-${index}`}>
                                                                                    <td className={rowClass}><div>{value.nomeAvaliacaoExtra}</div><span className='text-muted fw-bold fs-7'>{value.nomeModulo}</span></td>
                                                                                    <td className={`${rowClass} text-center fw-regular`}>{value.tipo}</td>
                                                                                    <td className={`${rowClass} text-wrap text-center fw-bold ${value.nota < 6 ? 'text-primary' : 'text-dark'}`}>{value.nota || 'N/A'}</td>
                                                                                    <td className={`${rowClass} text-center`}>{value.data_formatada || 'N/A'}</td>
                                                                                    <td className={`${rowClass} text-center`}>
                                                                                        <span className='text-primary cursor-pointer' onClick={() => { setShouldGeneratePDF({ show: true, id: value.idAvaliacao, nome: value.nomeAvaliacaoExtra, tipo: value.tipo }) }}>Visualizar</span>
                                                                                    </td>
                                                                                </tr>
                                                                            )
                                                                        })
                                                                    }
                                                                    {/* Avaliação de Reação */}
                                                                    {value.avaliacao_reacao && (
                                                                        <tr key={`reacao-${value.id}`}>
                                                                            <td className={rowClass}><div>Avaliação de Reação</div><span className='text-muted fw-bold fs-7'>{value.nome}</span></td>
                                                                            <td className={`${rowClass} text-center fw-regular`}>Reação</td>
                                                                            <td className={`${rowClass} text-wrap text-center fw-bold`}>-</td>
                                                                            <td className={`${rowClass} text-center`}>{value.avaliacao_reacao.data_formatada || 'N/A'}</td>
                                                                            <td className={`${rowClass} text-center`}>
                                                                                <span className='text-primary cursor-pointer' onClick={() => {
                                                                                    handleVerAvaliacaoReacao('Avaliação de Reação', { ...value.avaliacao_reacao, nomeModulo: value.nome });
                                                                                }}>Ver Respostas</span>
                                                                            </td>
                                                                        </tr>
                                                                    )}
                                                                    {/* Avaliação de Reação Híbrida */}
                                                                    {value.avaliacao_reacao_hibrido && (
                                                                        <tr key={`reacao-hibrido-${value.id}`}>
                                                                            <td className={rowClass}><div>Avaliação de Reação Híbrida</div><span className='text-muted fw-bold fs-7'>{value.nome}</span></td>
                                                                            <td className={`${rowClass} text-center fw-regular`}>Reação Híbrida</td>
                                                                            <td className={`${rowClass} text-wrap text-center fw-bold`}>-</td>
                                                                            <td className={`${rowClass} text-center`}>{value.avaliacao_reacao_hibrido.data_formatada || 'N/A'}</td>
                                                                            <td className={`${rowClass} text-center`}>
                                                                                <span className='text-primary cursor-pointer' onClick={() => {
                                                                                    handleVerAvaliacaoReacao('Avaliação de Reação Híbrida', { ...value.avaliacao_reacao_hibrido, nomeModulo: value.nome });
                                                                                }}>Ver Respostas</span>
                                                                            </td>
                                                                        </tr>
                                                                    )}
                                                                    <tr>
                                                                        <td colSpan={5} style={{ padding: 1 }} className='bg-dark'></td>
                                                                    </tr>
                                                                </>
                                                            )
                                                        })
                                                    }
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </Modal.Body>
            </Modal>

            <Modal size="lg" show={showModalEnviarProva} onHide={() => setShowModalEnviarProva(false)}>
                <Modal.Header closeButton>
                    <div className='row'>
                        <span className="fw-medium fs-4 text-primary">Enviar prova para...</span>
                        <span>Lorem ipsum dolor sit amet. Qui reprehenderit esse quo similique laudantium ex modi </span>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <section className="w-100 mt-5">
                        <div className="d-flex flex-column">
                            <div className="row d-flex align-items-center justify-content-between">
                                <div className="col-md-8">
                                    <div className="inner-addon right-addon">
                                        <i className="d-flex bi bi-search" />
                                        <input
                                            type="search"
                                            placeholder="Pesquise o aluno desejado...."
                                            className="form-control py-2"
                                        />
                                    </div>
                                </div>
                                <div className="d-flex mt-2 mt-md-0 align-items-center justify-content-end col-md-4">
                                    <select className="form-select py-2">
                                        <option disabled>Ordenação</option>
                                        <option value="1">Curso</option>
                                        <option value="2">Módulos</option>
                                        <option value="3">Em andamento</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </section>
                    <div className="row">
                        <div className="col-md-12">
                            <div className="body">
                                <div className="table-full-width mt-3 mb-3">
                                    <div className="table-responsive">
                                        <table className="table align-middle mt-1">
                                            <tbody>
                                                <tr className='text-nowrap border-white'>
                                                    <td>
                                                        <div className="d-flex align-items-center">
                                                            <div className="picture text-white bg-grey" style={{ cursor: 'pointer', fontSize: '22px', height: '42px', marginRight: '0px', width: '42px' }}>
                                                                <i className="bi bi-person" />
                                                            </div>
                                                        </div></td>
                                                    <td>Lorem Ipsum</td>
                                                    <td className='text-center fw-bold'>(99) 99999-9999</td>
                                                    <td className='text-center'>email@email.com</td>
                                                    <td className='text-center fw-bold'>
                                                        <input className="form-check-input border-primary" type="checkbox" />
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="d-flex justify-content-center mb-4">
                        <button type="submit" className="btn btn-primary text-white px-3 py-2">Enviar</button>
                    </div>
                </Modal.Body>
            </Modal>

            <Modal size="xl" show={showModalPratica} onHide={() => {
                setShowModalPratica(false);
                setListaPresencaSelected(false);
                setFotosSelected(false);
            }}>
                <form onSubmit={handleSubmitPratica(onSubmitPratica)}>
                    <Modal.Header closeButton className="bg-gradient-primary text-white">
                        <div className="d-flex align-items-center">
                            <i className="bi bi-plus-circle me-3 fs-4"></i>
                            <div>
                                <h4 className="mb-0 fw-bold">Registrar Prática</h4>
                                <small className="opacity-75">{usuarioSelecionado.nome_completo}</small>
                            </div>
                        </div>
                    </Modal.Header>
                    <Modal.Body className="p-4">
                        <div className="row g-4">
                            {/* Informações Básicas */}
                            <div className="col-12">
                                <div className="card border-0 shadow-sm">
                                    <div className="card-header bg-light">
                                        <h6 className="mb-0 text-primary fw-bold">
                                            <i className="bi bi-info-circle me-2"></i>
                                            Informações do Treinamento
                                        </h6>
                                    </div>
                                    <div className="card-body">
                                        <div className="row g-3">
                                            <div className="col-md-6">
                                                <label className="form-label fw-semibold">
                                                    <i className="bi bi-calendar-event me-1 text-primary"></i>
                                                    Data do Treinamento Prático
                                                </label>
                                                <input
                                                    type="datetime-local"
                                                    className={`form-control form-control ${errorsPratica.data_treinamento ? 'is-invalid' : ''}`}
                                                    {...registerPratica('data_treinamento', {
                                                        required: true
                                                    })}
                                                />
                                                {errorsPratica.data_treinamento && <div className="invalid-feedback">Campo obrigatório</div>}
                                            </div>
                                            <div className="col-md-6">
                                                <label className="form-label fw-semibold">
                                                    <i className="bi bi-geo-alt me-1 text-primary"></i>
                                                    Local do Treinamento
                                                </label>
                                                <input
                                                    type="text"
                                                    className={`form-control form-control ${errorsPratica.local_treinamento ? 'is-invalid' : ''}`}
                                                    {...registerPratica('local_treinamento', {
                                                        required: true
                                                    })}
                                                />
                                                {errorsPratica.local_treinamento && <div className="invalid-feedback">Campo obrigatório</div>}
                                            </div>
                                            <div className="col-12">
                                                <label className="form-label fw-semibold">
                                                    <i className="bi bi-person-badge me-1 text-primary"></i>
                                                    Gestor Responsável
                                                </label>
                                                <input
                                                    type="text"
                                                    className={`form-control form-control ${errorsPratica.gestor ? 'is-invalid' : ''}`}
                                                    {...registerPratica('gestor', {
                                                        required: true
                                                    })}
                                                />
                                                {errorsPratica.gestor && <div className="invalid-feedback">Campo obrigatório</div>}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Upload de Arquivos */}
                            <div className="col-12">
                                <div className="card border-0 shadow-sm">
                                    <div className="card-header bg-light">
                                        <h6 className="mb-0 text-primary fw-bold">
                                            <i className="bi bi-cloud-upload me-2"></i>
                                            Arquivos do Treinamento
                                        </h6>
                                        <small className="text-muted">Selecione os arquivos necessários para o registro</small>
                                    </div>
                                    <div className="card-body">
                                        <div className="row g-4">
                                            {/* Lista de Presença */}
                                            <div className="col-md-6">
                                                <label className="form-label fw-semibold">
                                                    <i className="bi bi-file-earmark-text me-1 text-success"></i>
                                                    Lista de Presença
                                                </label>
                                                <div className="upload-area">
                                                    <label
                                                        htmlFor="lista_presenca"
                                                        className={`upload-label ${listaPresencaSelected ? 'uploaded' : ''}`}
                                                    >
                                                        <div className="upload-content">
                                                            <i className={`bi ${listaPresencaSelected ? 'bi-check-circle-fill text-success' : 'bi-file-earmark-plus'} upload-icon`}></i>
                                                            <div className="upload-text">
                                                                <div className="fw-semibold">
                                                                    {listaPresencaSelected ? 'Arquivo Selecionado' : 'Selecionar Lista de Presença'}
                                                                </div>
                                                                <small className="text-muted">PDF ou Imagem</small>
                                                            </div>
                                                        </div>
                                                        {listaPresencaSelected && (
                                                            <div className="upload-badge">
                                                                <span className="badge bg-success">
                                                                    <i className="bi bi-check me-1"></i>
                                                                    1 arquivo
                                                                </span>
                                                            </div>
                                                        )}
                                                    </label>
                                                    <Controller
                                                        control={controlPratica}
                                                        name="lista_presenca"
                                                        rules={{
                                                            required: true
                                                        }}
                                                        render={({ field: { onChange, onBlur, ref } }) => (
                                                            <input
                                                                id="lista_presenca"
                                                                type="file"
                                                                style={{ display: 'none' }}
                                                                accept=".pdf,image/*"
                                                                onBlur={onBlur}
                                                                ref={ref}
                                                                onChange={(e) => {
                                                                    const files = e.target.files;
                                                                    onChange(files);
                                                                    setListaPresencaSelected(files && files.length > 0);
                                                                }}
                                                            />
                                                        )}
                                                    />
                                                </div>
                                                {errorsPratica.lista_presenca && <div className="invalid-feedback d-block">Campo obrigatório</div>}
                                            </div>

                                            {/* Fotos */}
                                            <div className="col-md-6">
                                                <label className="form-label fw-semibold">
                                                    <i className="bi bi-images me-1 text-info"></i>
                                                    Fotos do Treinamento
                                                </label>
                                                <div className="upload-area">
                                                    <label
                                                        htmlFor="fotos"
                                                        className={`upload-label ${fotosSelected ? 'uploaded' : ''}`}
                                                    >
                                                        <div className="upload-content">
                                                            <i className={`bi ${fotosSelected ? 'bi-check-circle-fill text-success' : 'bi-images'} upload-icon`}></i>
                                                            <div className="upload-text">
                                                                <div className="fw-semibold">
                                                                    {fotosSelected ? 'Fotos Selecionadas' : 'Selecionar Fotos'}
                                                                </div>
                                                                <small className="text-muted">Múltiplas imagens</small>
                                                            </div>
                                                        </div>
                                                        {fotosSelected && (
                                                            <div className="upload-badge">
                                                                <span className="badge bg-success">
                                                                    <i className="bi bi-check me-1"></i>
                                                                    Arquivos selecionados
                                                                </span>
                                                            </div>
                                                        )}
                                                    </label>
                                                    <Controller
                                                        control={controlPratica}
                                                        name="fotos"
                                                        rules={{
                                                            required: true
                                                        }}
                                                        render={({ field: { onChange, onBlur, value, ref } }) => (
                                                            <input
                                                                id="fotos"
                                                                type="file"
                                                                style={{ display: 'none' }}
                                                                multiple
                                                                accept="image/*"
                                                                onBlur={onBlur}
                                                                ref={ref}
                                                                onChange={(e) => {
                                                                    const files = e.target.files;
                                                                    onChange(files);
                                                                    setFotosSelected(files && files.length > 0);
                                                                }}
                                                            />
                                                        )}
                                                    />
                                                </div>
                                                {errorsPratica.fotos && <div className="invalid-feedback d-block">Campo obrigatório</div>}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer className="bg-light border-0 p-4">
                        <div className="d-flex gap-3 w-100">
                            <button
                                type="button"
                                className="btn btn-outline-secondary btn px-2"
                                onClick={() => {
                                    setShowModalPratica(false);
                                    setListaPresencaSelected(false);
                                    setFotosSelected(false);
                                }}
                            >
                                <i className="bi bi-x-circle me-2"></i>
                                Cancelar
                            </button>
                            <button
                                type="submit"
                                className="btn btn-primary btn px-2 ms-auto"
                                disabled={loadingRegistrar}
                            >
                                {loadingRegistrar ? (
                                    <>
                                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                        Processando...
                                    </>
                                ) : (
                                    <>
                                        <i className="bi bi-check-circle me-2"></i>
                                        Registrar Prática
                                    </>
                                )}
                            </button>
                        </div>
                    </Modal.Footer>
                </form>
            </Modal>

            <Modal size="xl" show={showModalVisualizarPratica} onHide={() => setShowModalVisualizarPratica(false)}>
                <Modal.Header closeButton className="bg-gradient-primary text-white">
                    <div className="d-flex align-items-center">
                        <i className={`bi ${praticaAtual && praticaAtual.arquivada ? 'bi-archive-fill' : 'bi-eye-fill'} me-3 fs-4`}></i>
                        <div>
                            <h4 className="mb-0 fw-bold">
                                {praticaAtual && praticaAtual.arquivada
                                    ? 'Prática Arquivada'
                                    : 'Detalhes da Prática'
                                }
                            </h4>
                            <small className="opacity-75">
                                {praticaAtual && praticaAtual.arquivada
                                    ? 'Esta prática foi arquivada'
                                    : 'Visualização completa dos dados'
                                }
                            </small>
                        </div>
                    </div>
                </Modal.Header>
                <Modal.Body className="p-4">
                    {praticaAtual && (
                        <div className="row g-4">
                            {/* Informações do Aluno e Curso */}
                            <div className="col-12">
                                <div className="card border-0 shadow-sm">
                                    <div className="card-header bg-light">
                                        <h6 className="mb-0 text-primary fw-bold">
                                            <i className="bi bi-person-circle me-2"></i>
                                            Informações do Aluno
                                        </h6>
                                    </div>
                                    <div className="card-body">
                                        <div className="row g-3">
                                            <div className="col-md-6">
                                                <div className="info-item">
                                                    <label className="info-label">
                                                        <i className="bi bi-person me-1 text-primary"></i>
                                                        Aluno
                                                    </label>
                                                    <p className="info-value">{praticaAtual.nome_usuario}</p>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="info-item">
                                                    <label className="info-label">
                                                        <i className="bi bi-book me-1 text-primary"></i>
                                                        Curso
                                                    </label>
                                                    <p className="info-value">{praticaAtual.nome_curso}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Detalhes do Treinamento */}
                            <div className="col-12">
                                <div className="card border-0 shadow-sm">
                                    <div className="card-header bg-light">
                                        <h6 className="mb-0 text-primary fw-bold">
                                            <i className="bi bi-calendar-event me-2"></i>
                                            Detalhes do Treinamento
                                        </h6>
                                    </div>
                                    <div className="card-body">
                                        <div className="row g-3">
                                            <div className="col-md-4">
                                                <div className="info-item">
                                                    <label className="info-label">
                                                        <i className="bi bi-calendar3 me-1 text-success"></i>
                                                        Data do Treinamento
                                                    </label>
                                                    <p className="info-value">
                                                        {new Date(praticaAtual.data_treinamento).toLocaleDateString('pt-BR', {
                                                            day: '2-digit',
                                                            month: '2-digit',
                                                            year: 'numeric',
                                                            hour: '2-digit',
                                                            minute: '2-digit'
                                                        })}
                                                    </p>
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="info-item">
                                                    <label className="info-label">
                                                        <i className="bi bi-geo-alt me-1 text-info"></i>
                                                        Local do Treinamento
                                                    </label>
                                                    <p className="info-value">{praticaAtual.local_treinamento}</p>
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="info-item">
                                                    <label className="info-label">
                                                        <i className="bi bi-person-badge me-1 text-warning"></i>
                                                        Gestor Responsável
                                                    </label>
                                                    <p className="info-value">{praticaAtual.gestor}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Arquivos */}
                            <div className="col-12">
                                <div className="card border-0 shadow-sm">
                                    <div className="card-header bg-light">
                                        <h6 className="mb-0 text-primary fw-bold">
                                            <i className="bi bi-files me-2"></i>
                                            Arquivos do Treinamento
                                        </h6>
                                    </div>
                                    <div className="card-body">
                                        <div className="row g-4">
                                            {/* Lista de Presença */}
                                            <div className="col-md-6">
                                                <div className="file-section">
                                                    <label className="file-section-label">
                                                        <i className="bi bi-file-earmark-text me-2 text-success"></i>
                                                        Lista de Presença
                                                    </label>
                                                    <div className="file-preview">
                                                        <a
                                                            href={`${process.env.REACT_APP_API_URL}/listapresenca/${praticaAtual.lista_presenca}`}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            className="btn btn-outline-success btn w-100"
                                                        >
                                                            <i className="bi bi-eye me-2"></i>
                                                            Visualizar Lista de Presença
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Fotos */}
                                            {praticaAtual.fotos && praticaAtual.fotos.length > 0 && (
                                                <div className="col-md-6">
                                                    <div className="file-section">
                                                        <label className="file-section-label">
                                                            <i className="bi bi-images me-2 text-info"></i>
                                                            Fotos do Treinamento
                                                            <span className="badge bg-info ms-2">{praticaAtual.fotos.length}</span>
                                                        </label>
                                                        <div className="photos-grid">
                                                            {praticaAtual.fotos.map((foto, index) => (
                                                                <div key={index} className="photo-item">
                                                                    <a
                                                                        href={`${process.env.REACT_APP_API_URL}/imagens/${foto.nome_arquivo}`}
                                                                        target="_blank"
                                                                        rel="noopener noreferrer"
                                                                        className="photo-link"
                                                                    >
                                                                        <img
                                                                            src={`${process.env.REACT_APP_API_URL}/imagens/${foto.nome_arquivo}`}
                                                                            alt={`Foto ${index + 1}`}
                                                                            className="photo-img"
                                                                        />
                                                                        <div className="photo-overlay">
                                                                            <i className="bi bi-zoom-in"></i>
                                                                        </div>
                                                                    </a>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Alerta de Prática Arquivada */}
                            {praticaAtual.arquivada && (
                                <div className="col-12">
                                    <div className="alert alert-warning border-0 shadow-sm">
                                        <div className="d-flex align-items-center">
                                            <i className="bi bi-exclamation-triangle-fill fs-4 me-3"></i>
                                            <div>
                                                <h6 className="alert-heading mb-1">Prática Arquivada</h6>
                                                <p className="mb-0">Esta prática foi arquivada porque o curso foi reiniciado. Você pode registrar uma nova prática para este curso.</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer className="bg-light border-0 p-4">
                    <div className="d-flex gap-3 w-100">
                        {praticaAtual && praticaAtual.arquivada ? (
                            <button
                                className="btn btn-primary btn px-2 ms-auto"
                                onClick={() => {
                                    setShowModalVisualizarPratica(false);
                                    setShowModalPratica(true);
                                }}
                            >
                                <i className="bi bi-plus-circle me-2"></i>
                                Registrar Nova Prática
                            </button>
                        ) : (
                            <>
                                <button
                                    className="btn btn-outline-danger btn px-2"
                                    onClick={() => {
                                        setShowModalVisualizarPratica(false);
                                        setShouldReopenDetailsModal(true);
                                        setShowModalConfirmacaoDeletar(true);
                                    }}
                                >
                                    <i className="bi bi-trash me-2"></i>
                                    Excluir
                                </button>
                                <button
                                    className="btn btn-primary btn px-2 ms-auto"
                                    onClick={handleEditarPratica}
                                >
                                    <i className="bi bi-pencil me-2"></i>
                                    Editar
                                </button>
                            </>
                        )}
                    </div>
                </Modal.Footer>
            </Modal>

            <Modal show={showModalConfirmacao} onHide={() => setShowModalConfirmacao(false)} size="lg" dialogClassName="modal-90w">
                <Modal.Header closeButton>
                    <span className="fw-semibold fs-4 text-primary">Confirmação</span>
                </Modal.Header>
                <Modal.Body>
                    <p>Você tem certeza que deseja {novoStatusCertificado ? 'liberar' : 'bloquear'} o certificado para este aluno?</p>
                    <p className="text-muted">Esta ação {novoStatusCertificado ? 'permitirá' : 'impedirá'} que o aluno tenha acesso ao certificado do curso.</p>
                </Modal.Body>
                <Modal.Footer>
                    <button
                        type="button"
                        className="btn btn-outline-primary"
                        onClick={() => setShowModalConfirmacao(false)}
                    >
                        Cancelar
                    </button>
                    <button
                        type="button"
                        className="btn btn-primary text-white"
                        onClick={confirmarMudancaCertificado}
                    >
                        Confirmar
                    </button>
                </Modal.Footer>
            </Modal>

            <Modal size="xl" show={showModalEditarPratica} onHide={() => {
                setShowModalEditarPratica(false);
                setListaPresencaEditSelected(false);
                setFotosEditSelected(false);
                setArquivosSelecionados({ listaPresenca: null, fotos: [] });
            }}>
                <form onSubmit={handleSubmitEditarPratica(onSubmitEditarPratica)}>
                    <Modal.Header closeButton className="bg-gradient-primary text-white">
                        <div className="d-flex align-items-center">
                            <i className="bi bi-pencil-square me-3 fs-4"></i>
                            <div>
                                <h4 className="mb-0 fw-bold">Editar Prática</h4>
                                <small className="opacity-75">{usuarioSelecionado.nome_completo}</small>
                            </div>
                        </div>
                    </Modal.Header>
                    <Modal.Body className="p-4">
                        <div className="row g-4">
                            {/* Informações Básicas */}
                            <div className="col-12">
                                <div className="card border-0 shadow-sm">
                                    <div className="card-header bg-light">
                                        <h6 className="mb-0 text-primary fw-bold">
                                            <i className="bi bi-info-circle me-2"></i>
                                            Informações do Treinamento
                                        </h6>
                                    </div>
                                    <div className="card-body">
                                        <div className="row g-3">
                                            <div className="col-md-6">
                                                <label className="form-label fw-semibold">
                                                    <i className="bi bi-calendar-event me-1 text-primary"></i>
                                                    Data do Treinamento Prático
                                                </label>
                                                <input
                                                    type="datetime-local"
                                                    className={`form-control form-control ${errorsEditarPratica.data_treinamento ? 'is-invalid' : ''}`}
                                                    {...registerEditarPratica('data_treinamento', {
                                                        required: true
                                                    })}
                                                />
                                                {errorsEditarPratica.data_treinamento && <div className="invalid-feedback">Campo obrigatório</div>}
                                            </div>
                                            <div className="col-md-6">
                                                <label className="form-label fw-semibold">
                                                    <i className="bi bi-geo-alt me-1 text-primary"></i>
                                                    Local do Treinamento
                                                </label>
                                                <input
                                                    type="text"
                                                    className={`form-control form-control ${errorsEditarPratica.local_treinamento ? 'is-invalid' : ''}`}
                                                    {...registerEditarPratica('local_treinamento', {
                                                        required: true
                                                    })}
                                                />
                                                {errorsEditarPratica.local_treinamento && <div className="invalid-feedback">Campo obrigatório</div>}
                                            </div>
                                            <div className="col-12">
                                                <label className="form-label fw-semibold">
                                                    <i className="bi bi-person-badge me-1 text-primary"></i>
                                                    Gestor Responsável
                                                </label>
                                                <input
                                                    type="text"
                                                    className={`form-control form-control ${errorsEditarPratica.gestor ? 'is-invalid' : ''}`}
                                                    {...registerEditarPratica('gestor', {
                                                        required: true
                                                    })}
                                                />
                                                {errorsEditarPratica.gestor && <div className="invalid-feedback">Campo obrigatório</div>}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Upload de Arquivos */}
                            <div className="col-12">
                                <div className="card border-0 shadow-sm">
                                    <div className="card-header bg-light">
                                        <h6 className="mb-0 text-primary fw-bold">
                                            <i className="bi bi-cloud-upload me-2"></i>
                                            Arquivos do Treinamento
                                        </h6>
                                        <small className="text-muted">Selecione novos arquivos para substituir os existentes</small>
                                    </div>
                                    <div className="card-body">
                                        <div className="row g-4">
                                            {/* Lista de Presença */}
                                            <div className="col-md-6">
                                                <label className="form-label fw-semibold">
                                                    <i className="bi bi-file-earmark-text me-1 text-success"></i>
                                                    Lista de Presença
                                                </label>
                                                <div className="upload-area">
                                                    <label
                                                        htmlFor="lista_presenca_edit"
                                                        className={`upload-label ${listaPresencaEditSelected ? 'uploaded' : ''}`}
                                                    >
                                                        <div className="upload-content">
                                                            <i className={`bi ${listaPresencaEditSelected ? 'bi-check-circle-fill text-success' : 'bi-file-earmark-plus'} upload-icon`}></i>
                                                            <div className="upload-text">
                                                                <div className="fw-semibold">
                                                                    {listaPresencaEditSelected ? 'Arquivo Selecionado' : 'Selecionar Lista de Presença'}
                                                                </div>
                                                                <small className="text-muted">
                                                                    {listaPresencaEditSelected ? arquivosSelecionados.listaPresenca?.name : 'PDF ou Imagem'}
                                                                </small>
                                                            </div>
                                                        </div>
                                                        {listaPresencaEditSelected && (
                                                            <div className="upload-badge">
                                                                <span className="badge bg-success">
                                                                    <i className="bi bi-check me-1"></i>
                                                                    1 arquivo
                                                                </span>
                                                            </div>
                                                        )}
                                                    </label>
                                                    <Controller
                                                        control={controlEditarPratica}
                                                        name="lista_presenca"
                                                        render={({ field: { onChange, onBlur, ref } }) => (
                                                            <input
                                                                id="lista_presenca_edit"
                                                                type="file"
                                                                style={{ display: 'none' }}
                                                                accept=".pdf,image/*"
                                                                onBlur={onBlur}
                                                                ref={ref}
                                                                onChange={(e) => {
                                                                    const files = e.target.files;
                                                                    onChange(files);
                                                                    setListaPresencaEditSelected(files && files.length > 0);
                                                                    setArquivosSelecionados(prev => ({
                                                                        ...prev,
                                                                        listaPresenca: files && files.length > 0 ? files[0] : null
                                                                    }));
                                                                }}
                                                            />
                                                        )}
                                                    />
                                                </div>
                                            </div>

                                            {/* Fotos */}
                                            <div className="col-md-6">
                                                <label className="form-label fw-semibold">
                                                    <i className="bi bi-images me-1 text-info"></i>
                                                    Fotos do Treinamento
                                                </label>
                                                <div className="upload-area">
                                                    <label
                                                        htmlFor="fotos_edit"
                                                        className={`upload-label ${fotosEditSelected ? 'uploaded' : ''}`}
                                                    >
                                                        <div className="upload-content">
                                                            <i className={`bi ${fotosEditSelected ? 'bi-check-circle-fill text-success' : 'bi-images'} upload-icon`}></i>
                                                            <div className="upload-text">
                                                                <div className="fw-semibold">
                                                                    {fotosEditSelected ? 'Fotos Selecionadas' : 'Selecionar Fotos'}
                                                                </div>
                                                                <small className="text-muted">
                                                                    {fotosEditSelected ? `${arquivosSelecionados.fotos.length} arquivo(s)` : 'Múltiplas imagens'}
                                                                </small>
                                                            </div>
                                                        </div>
                                                        {fotosEditSelected && (
                                                            <div className="upload-badge">
                                                                <span className="badge bg-success">
                                                                    <i className="bi bi-check me-1"></i>
                                                                    {arquivosSelecionados.fotos.length} arquivo(s)
                                                                </span>
                                                            </div>
                                                        )}
                                                    </label>
                                                    <Controller
                                                        control={controlEditarPratica}
                                                        name="fotos"
                                                        render={({ field: { onChange, onBlur, ref } }) => (
                                                            <input
                                                                id="fotos_edit"
                                                                type="file"
                                                                style={{ display: 'none' }}
                                                                multiple
                                                                accept="image/*"
                                                                onBlur={onBlur}
                                                                ref={ref}
                                                                onChange={(e) => {
                                                                    const files = e.target.files;
                                                                    onChange(files);
                                                                    setFotosEditSelected(files && files.length > 0);
                                                                    setArquivosSelecionados(prev => ({
                                                                        ...prev,
                                                                        fotos: files ? Array.from(files) : []
                                                                    }));
                                                                }}
                                                            />
                                                        )}
                                                    />
                                                </div>

                                                {/* Lista de arquivos selecionados */}
                                                {fotosEditSelected && arquivosSelecionados.fotos.length > 0 && (
                                                    <div className="mt-3">
                                                        <div className="selected-files">
                                                            <h6 className="text-success fw-semibold mb-2">
                                                                <i className="bi bi-list-ul me-1"></i>
                                                                Arquivos Selecionados:
                                                            </h6>
                                                            <div className="file-list">
                                                                {arquivosSelecionados.fotos.map((file, index) => (
                                                                    <div key={index} className="file-item">
                                                                        <i className="bi bi-image text-info me-2"></i>
                                                                        <span className="file-name">{file.name}</span>
                                                                        <span className="file-size text-muted">
                                                                            ({(file.size / 1024 / 1024).toFixed(2)} MB)
                                                                        </span>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer className="bg-light border-0 p-4">
                        <div className="d-flex gap-3 w-100">
                            <button
                                type="button"
                                className="btn btn-outline-secondary btn px-2"
                                onClick={() => {
                                    setShowModalEditarPratica(false);
                                    setShowModalVisualizarPratica(true);
                                    setListaPresencaEditSelected(false);
                                    setFotosEditSelected(false);
                                    setArquivosSelecionados({ listaPresenca: null, fotos: [] });
                                }}
                            >
                                <i className="bi bi-x-circle me-2"></i>
                                Cancelar
                            </button>
                            <button
                                type="submit"
                                className="btn btn-primary btn px-2 ms-auto"
                                disabled={loadingEditar}
                            >
                                {loadingEditar ? (
                                    <>
                                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                        Salvando...
                                    </>
                                ) : (
                                    <>
                                        <i className="bi bi-check-circle me-2"></i>
                                        Salvar Alterações
                                    </>
                                )}
                            </button>
                        </div>
                    </Modal.Footer>
                </form>
            </Modal>

            <Modal show={showModalConfirmacaoDeletar} onHide={() => {
                setShowModalConfirmacaoDeletar(false);
                if (shouldReopenDetailsModal) {
                    setShowModalVisualizarPratica(true);
                    setShouldReopenDetailsModal(false);
                }
            }} size="lg">
                <Modal.Header closeButton>
                    <span className="fw-semibold fs-4 text-primary">Confirmação</span>
                </Modal.Header>
                <Modal.Body>
                    <p>Você tem certeza que deseja excluir esta prática?</p>
                    <p className="text-muted">Esta ação não poderá ser desfeita e todos os arquivos associados serão removidos.</p>
                </Modal.Body>
                <Modal.Footer>
                    <button
                        type="button"
                        className="btn btn-outline-primary"
                        onClick={() => {
                            setShowModalConfirmacaoDeletar(false);
                            if (shouldReopenDetailsModal) {
                                setShowModalVisualizarPratica(true);
                                setShouldReopenDetailsModal(false);
                            }
                        }}
                    >
                        Cancelar
                    </button>
                    <button
                        type="button"
                        className="btn btn-danger"
                        onClick={handleDeletarPratica}
                    >
                        Excluir
                    </button>
                </Modal.Footer>
            </Modal>

            <Modal show={modalVerAvaliacaoReacao.show} onHide={() => setModalVerAvaliacaoReacao({ show: false, tipo: '', data: null })} size="xl">
                <Modal.Header closeButton>
                    <span className="fw-semibold fs-4 text-primary">
                        {modalVerAvaliacaoReacao.tipo === 'Avaliação de Reação Híbrida'
                            ? 'Avaliação de Reação Híbrida'
                            : 'Avaliação de Reação'}
                    </span>
                </Modal.Header>
                <Modal.Body>
                    {modalVerAvaliacaoReacao.data && (
                        <div className="container">
                            <div className="row mb-3">
                                <div className="col-12">
                                    <div className="d-flex justify-content-between">
                                        <h5 className="text-primary">{modalVerAvaliacaoReacao.data.nomeModulo}</h5>
                                        <span className="text-muted">Realizada em: {modalVerAvaliacaoReacao.data.data_formatada}</span>
                                    </div>
                                    <hr />
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-12">
                                    <div className="card mb-3">
                                        <div className="card-body">
                                            <h6 className="card-title text-primary">Respostas</h6>
                                            {modalVerAvaliacaoReacao.data.respostas ? (
                                                <div className="table-responsive">
                                                    <table className="table table-striped">
                                                        <thead>
                                                            <tr>
                                                                <th>Pergunta</th>
                                                                <th>Resposta</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {(() => {
                                                                try {
                                                                    if (modalVerAvaliacaoReacao.tipo === 'Avaliação de Reação' || modalVerAvaliacaoReacao.tipo === 'Avaliação de Reação Híbrida') {
                                                                        // Garantir que questoes e respostas estão em formato adequado
                                                                        const questoes = typeof modalVerAvaliacaoReacao.data.questoes === 'string'
                                                                            ? JSON.parse(modalVerAvaliacaoReacao.data.questoes)
                                                                            : modalVerAvaliacaoReacao.data.questoes;

                                                                        const respostas = typeof modalVerAvaliacaoReacao.data.respostas === 'string'
                                                                            ? JSON.parse(modalVerAvaliacaoReacao.data.respostas)
                                                                            : modalVerAvaliacaoReacao.data.respostas;

                                                                        return Array.isArray(questoes) && Array.isArray(respostas)
                                                                            ? questoes.map((questao, index) => (
                                                                                <tr key={index}>
                                                                                    <td>{questao}</td>
                                                                                    <td>{respostas[index]}</td>
                                                                                </tr>
                                                                            ))
                                                                            : <tr><td colSpan="2">Formato de dados inválido</td></tr>;
                                                                    } else {
                                                                        // Renderização para avaliações normais
                                                                        const respostasObj = typeof modalVerAvaliacaoReacao.data.respostas === 'string'
                                                                            ? JSON.parse(modalVerAvaliacaoReacao.data.respostas)
                                                                            : modalVerAvaliacaoReacao.data.respostas;

                                                                        const questoesObj = typeof modalVerAvaliacaoReacao.data.questoes === 'string'
                                                                            ? JSON.parse(modalVerAvaliacaoReacao.data.questoes)
                                                                            : modalVerAvaliacaoReacao.data.questoes;

                                                                        return Object.entries(respostasObj).map(([perguntaId, resposta], index) => {
                                                                            const questaoTexto = questoesObj[perguntaId]?.questao || `Pergunta ${Number(perguntaId) + 1}`;
                                                                            return (
                                                                                <tr key={index}>
                                                                                    <td>{questaoTexto}</td>
                                                                                    <td>{resposta}</td>
                                                                                </tr>
                                                                            );
                                                                        });
                                                                    }
                                                                } catch (error) {
                                                                    console.error('Erro ao renderizar avaliação:', error);
                                                                    return <tr><td colSpan="2">Erro ao processar os dados: {error.message}</td></tr>;
                                                                }
                                                            })()}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            ) : (
                                                <div className="alert alert-info">
                                                    <i className="bi bi-info-circle me-2"></i>
                                                    Não há detalhes disponíveis para as respostas desta avaliação.
                                                </div>
                                            )}
                                        </div>
                                    </div>

                                    {modalVerAvaliacaoReacao.data.comentarios && (
                                        <div className="card mb-3">
                                            <div className="card-body">
                                                <h6 className="card-title text-primary">Comentários</h6>
                                                <p>{modalVerAvaliacaoReacao.data.comentarios}</p>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <button
                        type="button"
                        className="btn btn-success"
                        onClick={exportarAvaliacaoReacaoExcel}
                    >
                        <i className="bi bi-file-excel me-2"></i>
                        Exportar Excel
                    </button>
                    <button
                        type="button"
                        className="btn btn-outline-primary"
                        onClick={() => setModalVerAvaliacaoReacao({ show: false, tipo: '', data: null })}
                    >
                        Fechar
                    </button>
                </Modal.Footer>
            </Modal>

            {/* Modal de Prática em Massa */}
            <Modal size="xl" show={showModalPraticaMassa} onHide={() => {
                setShowModalPraticaMassa(false);
                setListaPresencaMassaSelected(false);
                setFotosMassaSelected(false);
                setAlunosSelecionadosMassa([]);
            }}>
                <form onSubmit={handleSubmitPraticaMassa(onSubmitPraticaMassa)}>
                    <Modal.Header closeButton className="bg-gradient-primary text-white">
                        <div className="d-flex align-items-center">
                            <i className="bi bi-people-fill me-3 fs-4"></i>
                            <div>
                                <h4 className="mb-0 fw-bold">Registrar Prática em Massa</h4>
                                <small className="opacity-75">
                                    {alunosSelecionadosMassa.length} aluno(s) selecionado(s)
                                </small>
                            </div>
                        </div>
                    </Modal.Header>
                    <Modal.Body className="p-4">
                        <div className="row g-4">
                            {/* Seleção de Alunos */}
                            <div className="col-12">
                                <div className="card border-0 shadow-sm">
                                    <div className="card-header bg-light">
                                        <h6 className="mb-0 text-primary fw-bold">
                                            <i className="bi bi-person-check me-2"></i>
                                            Selecionar Alunos
                                        </h6>
                                        <small className="text-muted">Apenas alunos sem prática registrada aparecem na lista</small>
                                    </div>
                                    <div className="card-body">
                                        <Select
                                            isMulti
                                            options={filterAlunos
                                                .filter(aluno => !praticasRegistradas[aluno.id]?.ativa)
                                                .map(aluno => ({
                                                    value: aluno.id,
                                                    label: `${aluno.nome_completo} (${aluno.codigo})`,
                                                    ...aluno
                                                }))
                                            }
                                            value={alunosSelecionadosMassa}
                                            onChange={setAlunosSelecionadosMassa}
                                            placeholder="Selecione os alunos..."
                                            noOptionsMessage={() => "Nenhum aluno disponível"}
                                            className="react-select-container"
                                            classNamePrefix="react-select"
                                        />
                                        {alunosSelecionadosMassa.length === 0 && (
                                            <div className="text-muted mt-2">
                                                <i className="bi bi-info-circle me-1"></i>
                                                Selecione pelo menos um aluno para continuar
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>

                            {/* Informações Básicas */}
                            <div className="col-12">
                                <div className="card border-0 shadow-sm">
                                    <div className="card-header bg-light">
                                        <h6 className="mb-0 text-primary fw-bold">
                                            <i className="bi bi-info-circle me-2"></i>
                                            Informações do Treinamento
                                        </h6>
                                    </div>
                                    <div className="card-body">
                                        <div className="row g-3">
                                            <div className="col-md-6">
                                                <label className="form-label fw-semibold">
                                                    <i className="bi bi-calendar-event me-1 text-primary"></i>
                                                    Data do Treinamento Prático
                                                </label>
                                                <input
                                                    type="datetime-local"
                                                    className={`form-control form-control ${errorsPraticaMassa.data_treinamento ? 'is-invalid' : ''}`}
                                                    {...registerPraticaMassa('data_treinamento', {
                                                        required: true
                                                    })}
                                                />
                                                {errorsPraticaMassa.data_treinamento && <div className="invalid-feedback">Campo obrigatório</div>}
                                            </div>
                                            <div className="col-md-6">
                                                <label className="form-label fw-semibold">
                                                    <i className="bi bi-geo-alt me-1 text-primary"></i>
                                                    Local do Treinamento
                                                </label>
                                                <input
                                                    type="text"
                                                    className={`form-control form-control ${errorsPraticaMassa.local_treinamento ? 'is-invalid' : ''}`}
                                                    {...registerPraticaMassa('local_treinamento', {
                                                        required: true
                                                    })}
                                                />
                                                {errorsPraticaMassa.local_treinamento && <div className="invalid-feedback">Campo obrigatório</div>}
                                            </div>
                                            <div className="col-12">
                                                <label className="form-label fw-semibold">
                                                    <i className="bi bi-person-badge me-1 text-primary"></i>
                                                    Gestor Responsável
                                                </label>
                                                <input
                                                    type="text"
                                                    className={`form-control form-control ${errorsPraticaMassa.gestor ? 'is-invalid' : ''}`}
                                                    {...registerPraticaMassa('gestor', {
                                                        required: true
                                                    })}
                                                />
                                                {errorsPraticaMassa.gestor && <div className="invalid-feedback">Campo obrigatório</div>}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Upload de Arquivos */}
                            <div className="col-12">
                                <div className="card border-0 shadow-sm">
                                    <div className="card-header bg-light">
                                        <h6 className="mb-0 text-primary fw-bold">
                                            <i className="bi bi-cloud-upload me-2"></i>
                                            Arquivos do Treinamento
                                        </h6>
                                        <small className="text-muted">Os mesmos arquivos serão aplicados a todos os alunos selecionados</small>
                                    </div>
                                    <div className="card-body">
                                        <div className="row g-4">
                                            {/* Lista de Presença */}
                                            <div className="col-md-6">
                                                <label className="form-label fw-semibold">
                                                    <i className="bi bi-file-earmark-text me-1 text-success"></i>
                                                    Lista de Presença
                                                </label>
                                                <div className="upload-area">
                                                    <label
                                                        htmlFor="lista_presenca_massa"
                                                        className={`upload-label ${listaPresencaMassaSelected ? 'uploaded' : ''}`}
                                                    >
                                                        <div className="upload-content">
                                                            <i className={`bi ${listaPresencaMassaSelected ? 'bi-check-circle-fill text-success' : 'bi-file-earmark-plus'} upload-icon`}></i>
                                                            <div className="upload-text">
                                                                <div className="fw-semibold">
                                                                    {listaPresencaMassaSelected ? 'Arquivo Selecionado' : 'Selecionar Lista de Presença'}
                                                                </div>
                                                                <small className="text-muted">PDF ou Imagem</small>
                                                            </div>
                                                        </div>
                                                        {listaPresencaMassaSelected && (
                                                            <div className="upload-badge">
                                                                <span className="badge bg-success">
                                                                    <i className="bi bi-check me-1"></i>
                                                                    1 arquivo
                                                                </span>
                                                            </div>
                                                        )}
                                                    </label>
                                                    <Controller
                                                        control={controlPraticaMassa}
                                                        name="lista_presenca"
                                                        rules={{
                                                            required: true
                                                        }}
                                                        render={({ field: { onChange, onBlur, ref } }) => (
                                                            <input
                                                                id="lista_presenca_massa"
                                                                type="file"
                                                                style={{ display: 'none' }}
                                                                accept=".pdf,image/*"
                                                                onBlur={onBlur}
                                                                ref={ref}
                                                                onChange={(e) => {
                                                                    const files = e.target.files;
                                                                    onChange(files);
                                                                    setListaPresencaMassaSelected(files && files.length > 0);
                                                                }}
                                                            />
                                                        )}
                                                    />
                                                </div>
                                                {errorsPraticaMassa.lista_presenca && <div className="invalid-feedback d-block">Campo obrigatório</div>}
                                            </div>

                                            {/* Fotos */}
                                            <div className="col-md-6">
                                                <label className="form-label fw-semibold">
                                                    <i className="bi bi-images me-1 text-info"></i>
                                                    Fotos do Treinamento
                                                </label>
                                                <div className="upload-area">
                                                    <label
                                                        htmlFor="fotos_massa"
                                                        className={`upload-label ${fotosMassaSelected ? 'uploaded' : ''}`}
                                                    >
                                                        <div className="upload-content">
                                                            <i className={`bi ${fotosMassaSelected ? 'bi-check-circle-fill text-success' : 'bi-images'} upload-icon`}></i>
                                                            <div className="upload-text">
                                                                <div className="fw-semibold">
                                                                    {fotosMassaSelected ? 'Fotos Selecionadas' : 'Selecionar Fotos'}
                                                                </div>
                                                                <small className="text-muted">Múltiplas imagens</small>
                                                            </div>
                                                        </div>
                                                        {fotosMassaSelected && (
                                                            <div className="upload-badge">
                                                                <span className="badge bg-success">
                                                                    <i className="bi bi-check me-1"></i>
                                                                    Arquivos selecionados
                                                                </span>
                                                            </div>
                                                        )}
                                                    </label>
                                                    <Controller
                                                        control={controlPraticaMassa}
                                                        name="fotos"
                                                        rules={{
                                                            required: true
                                                        }}
                                                        render={({ field: { onChange, onBlur, value, ref } }) => (
                                                            <input
                                                                id="fotos_massa"
                                                                type="file"
                                                                style={{ display: 'none' }}
                                                                multiple
                                                                accept="image/*"
                                                                onBlur={onBlur}
                                                                ref={ref}
                                                                onChange={(e) => {
                                                                    const files = e.target.files;
                                                                    onChange(files);
                                                                    setFotosMassaSelected(files && files.length > 0);
                                                                }}
                                                            />
                                                        )}
                                                    />
                                                </div>
                                                {errorsPraticaMassa.fotos && <div className="invalid-feedback d-block">Campo obrigatório</div>}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <button
                            type="button"
                            className="btn btn-outline-secondary"
                            onClick={() => {
                                setShowModalPraticaMassa(false);
                                setListaPresencaMassaSelected(false);
                                setFotosMassaSelected(false);
                                setAlunosSelecionadosMassa([]);
                            }}
                        >
                            Cancelar
                        </button>
                        <button
                            type="submit"
                            className="btn btn-primary text-white"
                            disabled={loadingRegistrarMassa || alunosSelecionadosMassa.length === 0}
                        >
                            {loadingRegistrarMassa ? (
                                <>
                                    <span className="spinner-border spinner-border-sm me-2"></span>
                                    Registrando...
                                </>
                            ) : (
                                <>
                                    <i className="bi bi-check-circle me-2"></i>
                                    Registrar para {alunosSelecionadosMassa.length} aluno(s)
                                </>
                            )}
                        </button>
                    </Modal.Footer>
                </form>
            </Modal>

        </>
    )
}

export default ListaAlunos;